/** Created by azhou on 2019/4/2.*/
<template>
  <ul class="list-item">
    <li class="w-20 list-item-col">{{Index+1}}</li>
    <li class="w-100 list-item-col">{{Itemize.title}}</li>
    <li class="w-20 list-item-col">{{Itemize.exp_level}}</li>
    <li class="w-20 list-item-col">
      <img :src="Itemize.exp_icon ? '/images/grade/'+ Itemize.exp_icon : ''" height="24px">
    </li>
    <li class="w-20 list-item-col">{{Itemize.exp}}</li>
    <li class="w-20 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
        {{Itemize.verify | formatVar('verifyType')}}
    </li>
    <!-- <li class="w-50 list-item-col">
        {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
    </li> -->
    <li class="w-50 list-item-col-end text-link" v-if="$route.query.tab == '活跃等级'" 
      @click="$router.push({name:'GradeManage',query:{single:true,tab:'活跃明细',storeId:Itemize.id,GST:Itemize.title}})">查看</li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ItemizeRank',
    computed: {
      ...mapGetters(['storeInfo','isGroup'])
    },
    props:{
      Itemize:{},
      Index:{}
    }
  }
</script>
